import {CookieHandler} from "../global/cookieconsent/cookieHandler";
import {DebugComposableObject, DebugCookieEntry} from "./debugCookieEntry";
import axios from "axios";
import {computed, ref} from "vue";
import globalsObject from "@k/js/globalsObject";
import {OwayoKonfiPart} from "@k/js/owayoPartWithSelObs";
import {SingleShaderCreator} from "@k/js/shader/SingleShaderCreator";
import {HandleShaderCreator, ShaderCreator} from "@k/js/shader/OwayoShader";
import {KONFI_DESKTOP_POPUPS, useKonfiDesktopPopupStatusStore} from "@k/vue/store/VisibilityStatusStore";

export const SPEICHERE_ENTWURF_FUER_KUNDENKONFI = {
    displayString:computed(()=>"Kundenkonfi Entwurf speichern"),

    display: function () {
        $("<div id='kundenKonfi_saveDraft'>" +
            "<label>Kundenkonfi Name:</label><input type='text' id='kundenKonfiName'>" +
            "<button onclick='$(\"#kundenKonfi_saveDraft\").remove();'>Cancel</button><br><button onclick='SPEICHERE_ENTWURF_FUER_KUNDENKONFI.saveIt()'>Speichern</button>" +
            "   </div>").appendTo("body");
    },
    onclick:()=>(SPEICHERE_ENTWURF_FUER_KUNDENKONFI as any).display(),
    saveIt: function () {
        const kundenKonfiName = $("#kundenKonfiName").val();
        if (kundenKonfiName === '') {
            alert("bitte KonfiNamen eingeben!!");
            return false;
        }
        globalsObject.controller.selObController.makeAllLogosAndTextsUntouchable();
        globalsObject.actionController.saveEntwurf(false).then(function () {
            $.post(
                "/konfigurator_php/debug/write_KK_EntwurfsVorbelegung.php",
                {
                    DreiDModell: globalsObject.controller.model.getCurrentOwayoProduct().model,
                    saveID: globalsObject.controller.model.entwurf.getID(),
                    KundenKonfi: kundenKonfiName
                }
            )
                .done(function () {
                    alert("done");
                    $("#kundenKonfi_saveDraft").remove();
                });
        });
        return true;
    }
} as DebugComposableObject;

const DELETE_CACHE = () => axios.get("/konfigurator_php/debug/deleteCachedContent.php").then(r => alert(r.data));
const OWAYO_NOCACHING = new DebugCookieEntry(CookieHandler.NOCACHING_COOKIENAME, "Backend Ergebnisse nicht cachen");
const KONFI_DEVELOPEMENT_MODE = new DebugCookieEntry(CookieHandler.DEVMODE_COOKIENAME, "Konfi Developement Mode");
const SHOW_SHADEREDITOR = new DebugCookieEntry(CookieHandler.SHADEREDITOR_COOKIENAME, "km shader editor Button");

const DELETE_ALL_COOKIES_SET_NOCACHING = () => {
    document.cookie.split(";").forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    OWAYO_NOCACHING.toggle();
    alert("all cookies deleted, OWAYO_NOCACHING set")
}
const BUILDALLSHADERS = function () {
    let part;
    for (part in globalsObject.owayoJSViewer.modelParts) {
        // if (!owayoJSViewer.modelParts[part].hasZentralesAbgelegtesNichtEinfaerbbaresPartImage) {
        globalsObject.owayoJSViewer.modelParts[part].handleShader = HandleShaderCreator.createHandleShader(globalsObject.owayoJSViewer.modelParts[part] as OwayoKonfiPart);
        ShaderCreator.createShaders(globalsObject.owayoJSViewer.modelParts[part], globalsObject.owayoJSViewer.getPatterns(part));
        // }

    }
};

const SHADER_EDITOR = {
    onclick:()=>(SHADER_EDITOR as any).displayPopup(),
    displayString:  "Shader Editor",
    mode: "fragment", //"handle",
    send: function () {

        let partName, part;

        const shaderString = $("#debug_shaderEditArea").val();

        for (partName in globalsObject.owayoJSViewer.modelParts) {

            part = globalsObject.owayoJSViewer.modelParts[partName];
            if (!part.hasZentralesAbgelegtesNichtEinfaerbbaresPartImage) {
                if (this.mode === "handle") {
                    part.handleShader = HandleShaderCreator.createHandleShader(part, shaderString as string);
                } else {
                    part.shaders = [
                        SingleShaderCreator.createSingleShader(
                            part,
                            true,
                            part.selectableObjects,
                            part.selectableObjects.length
                            ,
                            shaderString as string
                        )
                    ];
                }
            }
        }
        $("#debug_popup").hide();
        globalsObject.owayoJSViewer.render();
    },
    fill: function (part) {
        if (this.mode === "handle") {
            $("#debug_shaderEditArea").val(globalsObject.owayoJSViewer.modelParts[part].handleShader.fragmentShader);
        } else {
            $("#debug_shaderEditArea").val(globalsObject.owayoJSViewer.modelParts[part].shaders[0].fragmentShader);
        }
    },
    displayPopup: function () {
        let part;
        const visibilityStore = useKonfiDesktopPopupStatusStore();
        visibilityStore.closePopup(KONFI_DESKTOP_POPUPS.DEBUG_MENU);
        const  debugPopup = $("#debug_popup");
        $("#shadereditorButtons").remove();
        debugPopup.append("<div id='shadereditorButtons'><button onclick='$(\"#debug_popup\").hide()'>Cancel</button><br><button onclick='VIEWERFEATURE.SHADER_EDITOR.send()'>Shader setzen</button></div>");
        const $select = $("#shader_edit_select");
        $select.empty();
        const selectedPart = (SHADER_EDITOR as any).getFrontLikePart();
        for (part in globalsObject.owayoJSViewer.modelParts) {
            if (!globalsObject.owayoJSViewer.modelParts[part].hasZentralesAbgelegtesNichtEinfaerbbaresPartImage) {
                $select.append("<option value='" + part + "' " + (part === selectedPart ? "selected" : "") + ">" + part + "</option>");
            }
        }
        debugPopup.show();
        this.fill(selectedPart);
    },
    getFrontLikePart() {
        for(const part in globalsObject.owayoJSViewer.modelParts) {
            if(part.match(/.*ront.*/)) {
                return part;
            }
        }
        return "";
    }
} as DebugComposableObject;

const LOCALIZER_MISSINGENTRIES = {
    errors: [] as string[],
    onclick:()=>(LOCALIZER_MISSINGENTRIES as any).showLog(),
    displayString:"Fehlende Übersetzungen anzeigen",
    showLog: function () {
        //
        // if (typeof (untranslatedFromTemplateCompiler) !== "undefined") {
        //     alert("UntranslatedFromTemplateCompiler\n" + untranslatedFromTemplateCompiler.join("\n"));
        // }
        // alert(VIEWERFEATURE.LOCALIZER_MISSINGENTRIES.errors.join("\n"));
    }
} as DebugComposableObject;
const LOG_COLOROBJECT = {
    onclick:()=>{
        const colorcode = prompt();
        (LOG_COLOROBJECT as any).execute(colorcode)
    },
    displayString:"console.log colorcode",
    execute(colorCode:string) {
        if(colorCode === "") {
            return;
        }
        console.log(globalsObject.controller.model.entwurf.getColorObjects().filter(c=>c.colorCode.toLowerCase().indexOf(colorCode.toLowerCase()) !==-1));
    }
} as DebugComposableObject


export const useDebugMenu = () => {

    return {
        SHOW_ALL_COLORS:createDebugComposableObjectFromObjectKey("SHOW_ALL_COLORS"),
        LOG_HIT_PARTS_in_CONSOLE:createDebugComposableObjectFromObjectKey("LOG_HIT_PARTS_in_CONSOLE"),
        DELETE_CACHE,
        USE_DROPPABLE_FROM_STOFF:createDebugComposableObjectFromObjectKey("USE_DROPPABLE_FROM_STOFF"),
        OWAYO_NOCACHING,
        KONFI_DEVELOPEMENT_MODE,
        SHOW_SHADEREDITOR,
        EDIT_MATERIALS:createDebugComposableObjectFromObjectKey("EDIT_MATERIALS"),
        PATTERN_WITHOUT_REPEAT:createDebugComposableObjectFromObjectKey("PATTERN_WITHOUT_REPEAT"),
        SPEICHERE_ENTWURF_FUER_KUNDENKONFI,
        DELETE_ALL_COOKIES_SET_NOCACHING,
        BUILDALLSHADERS,
        LOCALIZER_MISSINGENTRIES,
        LOG_COLOROBJECT,
        SHADER_EDITOR
    }
};

const createDebugComposableObjectFromObjectKey = (key:string):DebugComposableObject =>{
    const reference = ref(VIEWERFEATURE[key]);
    const toggle = ()=>{
        VIEWERFEATURE[key] = !VIEWERFEATURE[key];
        reference.value = VIEWERFEATURE[key];
    }

    return {
       onclick:()=>toggle(),
       displayString: computed(()=>key  + (reference.value ? "✔" : "❌"))
    } as DebugComposableObject
}

export const VIEWERFEATURE = {
    USE_DROPPABLE_FROM_STOFF: true,
    SHOW_ALL_COLORS: false,
    LOG_HIT_PARTS_in_CONSOLE: false,
    EDIT_MATERIALS: false,
    PATTERN_WITHOUT_REPEAT: false,
};

// noinspection JSUnusedGlobalSymbols
if (typeof (window) !== "undefined") {
    (window as any).VIEWERFEATURE = VIEWERFEATURE
}
